import FontAwesome from '@expo/vector-icons/FontAwesome';
import { useCallback } from 'react';
import { Image, View } from 'react-native';
import { Text } from '@/components/Text';
import colors from '@/config/colors';
import { styles } from './styles';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import Checkbox from '@/components/ui/therapist/Checkbox';

export function Row({
  hasImage,
  imageURL,
  title,
  hasTags,
  tags,
  insideSelected,
  onPress,
  wholeObject,
  isSelected,
  selectedLimit,
}) {
  const handlePress = useCallback((wholeObject, isSelected) => {
    return () => {
      onPress(wholeObject, isSelected);
    };
  }, []);

  const isDisabled = () => {
    if (selectedLimit && !isSelected) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <PressableNeolexon
      style={styles.rowWrapper}
      onPress={
        insideSelected
          ? handlePress(wholeObject)
          : handlePress(wholeObject, isSelected)
      }
    >
      <View style={styles.rowContainer}>
        <View style={styles.rowFlexOne}>
          {hasImage ? (
            <Image
              resizeMode="contain"
              style={styles.rowImage}
              source={{ uri: imageURL }}
            />
          ) : null}
        </View>
        <View style={styles.rowFlexThree}>
          <Text style={styles.tagsTitle}>{title}</Text>
          {hasTags ? (
            <View style={styles.tagsContainer}>
              {tags.map((tag) => (
                <View style={styles.tag} key={tag}>
                  <Text style={styles.tagText}>{tag}</Text>
                </View>
              ))}
            </View>
          ) : null}
        </View>
        <View style={[styles.rowFlexOne, styles.rowContainerAction]}>
          {insideSelected ? (
            <FontAwesome name="close" size={20} color={colors.darkGrey} />
          ) : (
            <Checkbox
              onPress={() => onPress(wholeObject, isSelected)}
              isSelected={isSelected}
              disabled={isDisabled()}
            />
          )}
        </View>
      </View>
    </PressableNeolexon>
  );
}
